import React from "react";
import Navbar from "../../components/Commons/Navbar";
import Footer from "../../components/Layouts/Footer";
const Policies = () => {
  return (
    <div className="home">
      <Navbar />
      <div className="page_area clearfix" id="politicas">
        <div className="container h-100">
          <div className="row h-100 align-items-center justify-content-md-center">
            <div className="col-12 col-md-6">
              <div className="page-heading text-uppercase">
                <h2>
                  POLÍTICAS DE PRIVACIDAD Y PROTECCIÓN DE DATOS WONG PRIME
                </h2>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="bg-white">
        <div className="container py-5">
          <div className="row justify-content-md-center">
            <div className="col-12 col-lg-10 text-muted">
            <h3 className="f21">Política de Privacidad</h3>
              <h3 className="f18">1.- INTRODUCCIÓN</h3>
              <p className="f14" align="justify">
                CENCOSUD RETAIL PERÚ S.A. (en adelante “Wong Prime”), con RUC Nº 20109072177, y con domicilio en Calle
                Augusto Angulo Nº 130, Urb. San Antonio, distrito de Miraflores, Provincia y Departamento de Lima, asegura la
                máxima reserva y protección sobre aquellos datos personales de los clientes/usuarios que sean ingresados en el
                sitio en Internet de su propiedad:<a href="http://www.wongprime.pe" target="_blank" rel="noopener noreferrer">http://www.wongprime.pe</a>
              </p>
              <p className="f14" align="justify">
                En este documento describimos la “Política de Privacidad” (en adelante, también
                denominado “Política”) que se aplicará a todos los tratamientos de datos personales
                realizados por Wong Prime, que se deriven del ingreso de los clientes/usuarios al sitio
                web.
              </p>

              <h3 className="f18">2. OBJETIVO Y FINALIDAD</h3>
              <p className="f14" align="justify">
                En Wong Prime estamos especialmente interesados en ofrecer a nuestros clientes/
                usuarios el más alto nivel de seguridad y proteger la confidencialidad de los datos que
                nos aporta, dado que somos conscientes de la importancia que tiene la privacidad de
                los datos personales de nuestros clientes/usuarios. Siendo consecuentes con esta
                consideración tenemos el compromiso de respetar su privacidad y proteger la
                confidencialidad de su información privada y datos personales. Por ello, las relaciones
                comerciales se realizan en un entorno de servidor seguro bajo protocolo SSL (Secure
                Socket Layer), actualmente empleado por las empresas más importantes del mundo
                para realizar transacciones electrónicas seguras.
              </p>
              <p className="f14" align="justify">
                Nuestro sitio web ha sido creado y diseñado para facilitar todo tipo de información que
                creemos puede ser de interés y crear así un espacio de comunicación para los
                clientes/usuarios. El objetivo de esta Política es dar a conocer la manera en que se
                recogen, se tratan y se protegen los datos personales a los que accedemos a través
                de los formularios disponibles en el sitio web.
              </p>

              <h3 className="f18">3. ALCANCE</h3>
              <p className="f14" align="justify">
                La presente Política será aplicable a todos los datos personales que Wong Prime
                recoja, almacene, procese y utilice a través de su sitio web; así como a aquellos datos
                derivados de las interacciones y transacciones que los clientes/usuarios realicen en
                dicho portal.
              </p>
              <p className="f14" align="justify">
                Esta política se extiende a todos los bancos de datos, archivos, y sistemas de
                tratamiento que contengan información personal de los clientes/usuarios,
                independientemente del formato, medio o plataforma en que estos se encuentren.
                Asimismo, se aplicará a los datos recopilados tanto de manera directa a través de los
                formularios disponibles en el sitio web, como aquellos que puedan ser recolectados
                indirectamente mediante el uso de cookies o tecnologías similares.
              </p>

              <h3 className="f18">4. LEGISLACIÓN</h3>
              <p className="f14" align="justify">
                La presente Política es regulada por la legislación peruana y en particular por las
                siguientes normas en materia de protección de datos personales:
              </p>
              <ul className="f14">
                <li>Ley N° 29733, Ley de Protección de Datos Personales (en adelante, LPDP).</li>
                <li>
                  Decreto Supremo N° 016-2024-JUS, que aprueba el Reglamento de la Ley N°
                  29733 (en adelante, Reglamento de la LPDP).
                </li>
                <li>
                  Directiva de Seguridad de la Información, aprobada por la Resolución Directoral
                  N° 019-2013-JUS/DGPDP (en adelante, Directiva de Seguridad).
                </li>
                <li>
                  Directiva de Tratamiento de Datos Personales mediante Sistemas de
                  Videovigilancia, aprobada por Resolución Directoral N° 02-2020-JUS/DGTAIPD (en
                  adelante, Directiva de Videovigilancia).
                </li>
                <li>
                  Guía práctica para la observancia del “Deber de informar” emitida por la Autoridad
                  Nacional de Protección de Datos Personales, aprobada mediante Resolución
                  Directoral N° 80-2019-JUS/DGTAIPD de fecha 05 de noviembre de 2019.
                </li>
                <li>
                  Directiva para el Tratamiento de Datos Personales mediante Sistemas de
                  Videovigilancia, emitida por la Autoridad Nacional de Protección de Datos
                  Personales, aprobada mediante Resolución Directoral N° 02-2020-JUS/DGTAIPD
                  de fecha 10 de enero de 2020.
                </li>
              </ul>

              <h3 className="f18">5. TRATAMIENTO DE DATOS PERSONALES</h3>
              <p className="f14" align="justify">
                De acuerdo con la LPDP y su Reglamento, se entiende por datos personales toda
                información numérica, alfabética, gráfica, fotográfica, acústica, sobre hábitos
                personales, de localización, identificadores en línea o de cualquier otro tipo
                concerniente a aspectos físicos, económicos, culturales o sociales de las personas
                naturales que las identifica o las hace identificables. Se considera identificable cuando
                se puede verificar la identidad de la persona de manera directa o indirectamente a
                partir de la combinación de datos a través de medios que puedan ser razonablemente
                utilizados.
              </p>
              <p className="f14" align="justify">
                Asimismo, se entiende por tratamiento de datos personales a cualquier operación o
                procedimiento técnico, automatizado o no, que permite la recopilación, registro,
                organización, almacenamiento, conservación, elaboración, modificación, extracción,
                consulta, utilización, bloqueo, supresión, comunicación por transferencia o por difusión
                o cualquier otra forma de procesamiento que facilite el acceso, correlación o
                interconexión de los datos personales.
              </p>
              <p className="f14" align="justify">
                Wong Prime desarrolla la presente Política en atención a los principios rectores
                establecidos en la LPDP y su Reglamento, y, por tanto:
              </p>
              <ul className="f14">
                <li>
                  De acuerdo con el principio de legalidad, Wong Prime rechaza la
                  recopilación de los datos personales por medios fraudulentos, desleales o
                  ilícitos (artículo 4 de la LPDP).
                </li>
                <br />
                <li>
                  Conforme al principio de consentimiento, Wong Prime asegura que para el
                  tratamiento de los datos personales mediará el consentimiento que otorgue
                  el cliente/usuario (artículo 5 de la LPDP).
                </li>
                <br />
                <li>
                  Wong Prime garantiza que los datos personales facilitados por el cliente/
                  usuario se recopilarán para una finalidad determinada explícita y lícita, y no
                  se extenderá a otra finalidad que no haya sido la establecida de manera
                  inequívoca como tal al momento de su recopilación, excluyendo los casos
                  de actividades de valor histórico, estadístico o científico cuando se utilice
                  un procedimiento de disociación o anonimización (artículo 6 de la LPDP).
                </li>
                <br />
                <li>
                  Todo tratamiento de datos personales que realice Wong Prime será
                  adecuado, relevante y no excesivo a la finalidad para la que estos hubiesen
                  sido recopilados (artículo 7 de la LPDP).
                </li>
                <br />
                <li>
                  Los datos personales que vayan a ser tratados por Wong Prime serán veraces, exactos y, en la medida de lo
                  posible, actualizados, necesarios, pertinentes y adecuados respecto de la finalidad para la que fueron
                  recopilados. Se conservarán de forma tal que se garantice su seguridad y solo por el tiempo necesario para
                  cumplir con la finalidad del tratamiento (artículo 8 de la LPDP).
                </li>
                <br />
                <li>
                  Wong Prime como los encargados de tratamiento adoptan las medidas técnicas, organizativas y legales necesarias
                  para garantizar la seguridad y confidencialidad de los datos personales. Wong Prime cuenta con las medidas de
                  seguridad apropiadas, acorde con el tratamiento que se vaya a efectuar y con la categoría de datos personales
                  de que se trate (artículo 9 de la LPDP).
                </li>
                <br />
                <li>
                  Wong Prime informa a clientes/usuarios que pueden ejercer sus derechos contenidos en el derecho constitucional a
                  la protección de datos personales en sede administrativa ante la Autoridad Nacional de Protección de Datos y en
                  sede jurisdiccional ante el Poder Judicial a los efectos del inicio del correspondiente proceso de habeas
                  data.
                </li>
                <br />
                <li>
                  Wong Prime garantiza el nivel adecuado de protección de los datos personales para el flujo transfronterizo de
                  datos personales, con un mínimo de protección equiparable a lo previsto por la LPDP o por los estándares
                  internacionales de la materia (artículo 11 de la LPDP).
                </li>
                <br />
                <li>
                  Wong Prime informa a los clientes/usuarios, de manera permanente, clara, fácil de entender y accesible, sobre
                  las condiciones del tratamiento de sus datos personales, así como de los derechos que puede hacer valer
                  respecto a aquellos y de las demás condiciones establecidas en la LPDP (numeral 1 del artículo IX del Reglamento
                  de la LPDP).
                </li>
                <br />
                <li>
                  En el tratamiento de los datos personales, Wong Prime aplica las medidas legales, técnicas y organizativas a fin
                  de garantizar el cumplimiento efectivo de la normativa de datos personales, y es capaz de demostrar tal
                  cumplimiento (numeral 2 del artículo IX del Reglamento de la LPDP).
                </li>
              </ul>

              <h3 className="f18">6. CONSENTIMIENTO</h3>
              <p className="f14" align="justify">
                En cumplimiento de lo dispuesto en el numeral 13.5 del artículo 13 de la LPDP, la
                publicación de la presente Política debe entenderse como una forma de cumplimiento
                del deber de información que no exonera del requisito de obtener el consentimiento de
                usuarios/cliente. En ese sentido, Wong Prime solicita oportunamente el consentimiento
                libre, previo, expreso e informado al cliente/usuario:
              </p>
              <p className="f14" align="justify">
                <b>(i) Libre.</b> Denota que no debe mediar error, mala fe, violencia o dolo que puedan
                afectar la manifestación de voluntad del titular de los datos personales. De este
                modo, el condicionamiento de la prestación de un servicio sí afecta la libertad
                de quien otorga consentimiento para el tratamiento de sus datos personales si
                los datos solicitados no son indispensables para la prestación de los beneficios
                o servicios.
              </p>
              <p className="f14" align="justify">
                <b>(ii) Previo.</b> Significa que el consentimiento debe ser otorgado por el titular, a más
                tardar en el momento de la recolección de los datos personales.
              </p>
              <p className="f14" align="justify">
                <b>(iii) Expreso.</b> Refiere que el consentimiento del titular debe ser explícito y concreto, no son válidas las
                autorizaciones abiertas y no específicas. Se requiere que el Titular manifieste su voluntad de autorizar que Wong
                Prime realice el tratamiento de sus datos personales.
              </p>
              <p className="f14" align="justify">
                <b>(iv) Informado.</b> Cuando al titular de los datos personales se le informa de forma
                clara, expresa e indubitable, con lenguaje sencillo, sobre lo siguiente: (i) la
                identidad y domicilio o dirección del titular del banco de datos personales o del
                responsable del tratamiento al que puede dirigirse para revocar el
                consentimiento o ejercer sus derechos; (ii) la finalidad o finalidades del
                tratamiento a las que sus datos serán sometidos; (iii) la identidad de los que
                son o pueden ser sus destinatarios, de ser el caso; (iv) la existencia del banco
                de datos personales en que se almacenarán, cuando corresponda; (v) el
                carácter obligatorio o facultativo de sus respuestas al cuestionario que se le
                proponga, cuando sea el caso; (vi) las consecuencias de proporcionar sus
                datos personales y de su negativa a hacerlo y (vii) en su caso, la transferencia
                nacional e internacional de datos que se efectúen.
              </p>

              <h3 className="f18">7. INFORMACIÓN QUE RECOLECTAMOS</h3>
              <p className="f14" align="justify">
                Wong Prime, como responsables del tratamiento, a través de los formularios subidos
                en nuestra página web y en documentos análogos, así como a través de proveedores
                de servicios, redes sociales, registros públicos y fuentes accesibles al público, puede
                recopilar los siguientes datos:
              </p>
              <ul className="f14">
                <li>Nombres</li>
                <li>Dirección</li>
                <li>Teléfono</li>
                <li>Correo electrónico</li>
                <li>Número de documento de identidad</li>
              </ul>
              <p className="f14" align="justify">
                Adicionalmente, en el futuro y para actividades comerciales específicas Wong Prime podrá recopilar otros datos
                personales a fin de darles tratamiento en el marco de dichas campañas. En estos casos, Wong Prime informará
                oportunamente al cliente —en momento previo a la obtención del consentimiento— sobre la finalidad y tratamientos
                que brindará a dicha información y, adicionalmente, actualizará esta sección de la presente Política de
                Privacidad describiendo dichos datos adicionales a fin de que sean conocidos por nuestros clientes.
              </p>

              <h3 className="f18">8. FINALIDAD DEL TRATAMIENTO DE LOS DATOS PERSONALES</h3>
              <p className="f14" align="justify">
                Los datos personales que recopila Wong Prime estarán relacionados con una finalidad determinada, explícita y lícita.
                Las finalidades de tratamiento de los datos personales que nuestros clientes/usuarios introducen en los diferentes
                formularios del sitio web se orientan a gestionar las transacciones de compra de nuestros productos, contestación
                de sus consultas, peticiones y la atención de cualquier otro tipo de información que nos requieran a través de
                éstos.
              </p>
              <p className="f14" align="justify">
                A continuación, se detallan las finalidades específicas del tratamiento de los datos personales realizado por Wong
                Prime, en consideración a las actividades y los servicios que presta:
              </p>
              <ul className="f14">
                <li>Conocer las preferencias de los clientes en cuanto a nuevos productos y/o fidelización.</li>
                <li>Gestionar la información económica y contable de los clientes.</li>
                <li>Gestionar las listas de clientes</li>
                <li>Cumplir con fines estadísticos, históricos o científicos.</li>
                <li>Realizar comercio electrónico.</li>
                <li>Prestar servicios de solvencia patrimonial y de crédito.</li>
                <li>Verificar el cumplimiento/incumplimiento de obligaciones dinerarias.</li>
                <li>
                  Recopilar los datos de las personas que presentan requerimientos y reclamos a través del libro de reclamaciones
                  online.
                </li>
                <li>Atender los reclamos de los clientes.</li>
                <li>
                  Recopilar los datos personales de los prospectos de clientes para ofrecer productos y servicios; así como, con
                  fines de fidelización.
                </li>
              </ul>
              <p className="f14" align="justify">
                Informamos que, si nuestros clientes/usuarios autorizan el tratamiento para “Finalidades Adicionales” o
                secundarias mediante el marcado voluntario de las casillas correspondientes incorporadas en el sitio Web
                procederemos a tratar dichos datos para:
              </p>
              <ul className="f14">
                <li>
                  Envío de publicidad: Enviar al cliente información comercial, promocional y/o publicitaria con relación a los
                  diversos productos y/o servicios brindados por las unidades de negocio operadas por Cencosud Retail Perú S.A. en
                  el territorio nacional, es decir, Wong Prime, mediante el envío de correos electrónicos, llamadas al teléfono fijo
                  y/o teléfono celular, envío de whatsapp y sms;
                </li>
                <li>
                  Elaboración de perfiles: Registrar y analizar historiales de compra, elaborar perfiles de compra, ejecutar
                  acciones de prospección comercial, almacenar y tratar la información con fines estadísticos o históricos;
                </li>
                <li>
                  Recibir beneficios: Brindar beneficios (personalizados o generales), obsequios e invitaciones a diversos eventos
                  organizados por Wong Prime, los que serán asignados conforme a los criterios que oportunamente definirá
                  Cencosud Retail Perú S.A.
                </li>
              </ul>
              <p className="f14" align="justify">
                Asimismo, informamos que en caso nuestros clientes/usuarios, no acepten el (los) tratamiento (s) adicional (es) de
                sus datos personales, esto no afectará la prestación del servicio contratado.
              </p>
              <p className="f14" align="justify">
                Los datos personales facilitados por nuestros clientes/usuarios se almacenarán en los bancos de datos que forman
                parte del sistema de información de Wong Prime y serán tratados para poder llevar a cabo las finalidades expuestas
                anteriormente.
              </p>
              <p className="f14" align="justify">
                Los bancos de datos que están registrados actualmente ante la Autoridad de Protección de Datos Personales son los
                siguientes:
              </p>

              <table className="table table-bordered">
                <thead>
                  <tr align="center">
                    <th>Denominación</th>
                    <th>Código de Registro</th>
                    <th>Finalidad</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>CLIENTES</td>
                    <td>RNPDP-PJP N.º 1680</td>
                    <td>Conocer las preferencias de los clientes y potenciales clientes en cuanto a nuevos productos y/o fidelización.</td>
                  </tr>
                </tbody>
                <tbody>
                  <tr>
                    <td>COLABORADORES</td>
                    <td>RNPDP-PJP N.º 1681</td>
                    <td>Gestión y administración de los recursos humanos de la empresa y cumplimiento de la normativa laboral.</td>
                  </tr>
                </tbody>
                <tbody>
                  <tr>
                    <td>CONTRO DE ACCESOS</td>
                    <td>RNPDP-PJP N.º 1682</td>
                    <td>Gestión y control de los accesos a los sistemas informáticos de la empresa.</td>
                  </tr>
                </tbody>
                <tbody>
                  <tr>
                    <td>PROVEEDORES</td>
                    <td>RNPDP-PJP N.º 1683</td>
                    <td>Gestión y control de los proveedores de la empresa.</td>
                  </tr>
                </tbody>
                <tbody>
                  <tr>
                    <td>RECLUTAMIENTO DE COLABORADORES</td>
                    <td>RNPDP-PJP N.º 1684</td>
                    <td>Gestión y control de los colaboradores de la empresa.</td>
                  </tr>
                </tbody>
                <tbody>
                  <tr>
                    <td>SEGURIDAD Y SALUD EN EL TRABAJO</td>
                    <td>RNPDP-PJP N.º 1685</td>
                    <td>Gestión y control de la seguridad y salud en el trabajo de la empresa.</td>
                  </tr>
                </tbody>
                <tbody>
                  <tr>
                    <td>VIDEOVIGILANCIA</td>
                    <td>RNPDP-PJP N.º 1686</td>
                    <td>Gestión y control de la videovigilancia de la empresa.</td>
                  </tr>
                </tbody>
                <tbody>
                  <tr>
                    <td>QUEJAS Y RECLAMOS</td>
                    <td>RNPDP-PJP N.º 18061</td>
                    <td>Recopilar los datos de las personas que presentan requerimientos y reclamos a través del libro de reclamaciones físico y online para brindar respuesta.</td>
                  </tr>
                </tbody>
                <tbody>
                  <tr>
                    <td>PROSPECTOS DE CLIENTES</td>
                    <td>RNPDP-PJP N.º 24751</td>
                    <td>Recopilar los datos personales de los prospectos de clientes para ofrecer productos y servicios; así como, con fines de fidelización.</td>
                  </tr>
                </tbody>
              </table>

              <p className="f14" align="justify">
                Cabe destacar que este apartado se actualizará conforme se hagan modificaciones en los bancos de datos.
              </p>
              <p className="f14" align="justify">
                La dirección del titular del banco de datos es la siguiente: Calle Augusto Angulo N° 130. Urbanización San
                Antonio, distrito de Miraflores, provincia y departamento de Lima.
              </p>
              <p className="f14" align="justify">
                La información que se recaba a través de los formularios y/o documentos análogos alojados en el sitio web de Wong
                Prime se almacenarán en el banco de datos denominado CLIENTES, inscrito ante la Autoridad de Protección de Datos
                Personales con el código RNPDP-PJP N° 1680.
              </p>
              <p className="f14" align="justify">
                En ese sentido, los bancos de datos que contienen datos personales han sido inscritos en el Registro de
                Protección de Datos de la Autoridad de Protección de Datos Personales. Los datos personales que faciliten nuestros
                clientes/usuarios sólo podrán ser conocidos y manejados por el personal de Wong Prime que necesite conocer dicha
                información para poder enviar información o contestar las solicitudes de nuestros clientes/usuarios. Estos datos
                personales serán tratados de forma leal y lícita y no serán utilizados para otras finalidades incompatibles con las
                especificadas.
              </p>

              <h3 className="f18">9. CALIDAD DE LOS DATOS PERSONALES</h3>

              <p className="f14" align="justify">
                Los datos personales a los que Wong Prime tenga acceso serán aquellos que los
                clientes/usuarios faciliten voluntariamente rellenando los formularios puestos a tal
                efecto.
              </p>
              <p className="f14" align="justify">
                Los datos personales solicitados a nuestros clientes/usuarios son datos adecuados,
                pertinentes y no excesivos en relación con la finalidad para los que se recogen.
              </p>
              <p className="f14" align="justify">
                Los datos personales facilitados por nuestros clientes/usuarios tienen que ser exactos
                y correctos de forma que respondan con veracidad a su situación actual; caso
                contrario, estos datos serán cancelados.
              </p>
              <p className="f14" align="justify">
                Los datos personales facilitados son recopilados para el cumplimiento de las
                finalidades expuestas en este documento y no se usarán para otras finalidades
                incompatibles con las especificadas.
              </p>
              <p className="f14" align="justify">
                Los datos personales serán cancelados cuando hayan dejado de ser necesarios para
                las finalidades para las cuales han sido recopilados. Sin embargo, se conservarán
                durante el tiempo en qué pueda exigirse algún tipo de responsabilidad a Wong Prime
                derivada de esta relación con nuestros clientes/usuarios.
              </p>


              <h3 className="f18">10. COMUNICACIÓN DE DATOS PERSONALES</h3>
              <p className="f14" align="justify">
                Wong Prime podrá transferir los datos personales de sus clientes/usuarios a terceros, quienes actuarán en
                calidad de encargados de tratamiento de dichos datos personales y actuarán en observancia de la normativa de
                protección de datos personales.
              </p>
              <p className="f14" align="justify">
                Los terceros a quienes Wong Prime podrá transferir los datos personales son aquellos proveedores mencionados en
                el siguiente enlace:{' '}
                <a href="https://www.wong.pe/legales/privacidad-datos-proveedores" target="_blank" rel="noopener noreferrer">
                  https://www.wong.pe/legales/privacidad-datos-proveedores
                </a>
                . Estos proveedores estarán autorizados a utilizar sus datos personales sólo cuando sea necesario para
                proporcionarnos sus servicios. 
                
                <br />
                <br />
                Asimismo, Wong Prime podrá transferir los datos personales recopilados a las
                autoridades públicas competentes que los requieran por escrito o a quienes deba entregarse la información de
                acuerdo con la legislación aplicable, incluyendo Policía Nacional, Ministerio Público, programas sociales,
                administración tributaria, autoridades reguladoras, entre otras que estén facultadas a hacer dicho requerimiento.
              </p>
              <p className="f14" align="justify">
                En Wong Prime respetamos la privacidad de nuestros clientes/usuarios; por lo cual, no compartiremos su
                información con terceros si usted no desea expresamente que lo hagamos. No obstante, es conveniente que
                nuestros clientes/usuarios sepan que sus datos personales podrán ser comunicados por transferencia a las
                entidades administrativas, autoridades judiciales y/o policiales, siempre y cuando esté establecido por Ley.
              </p>

              <h3 className="f18">11. FLUJO TRANSFRONTERIZO DE DATOS PERSONALES</h3>
              <p className="f14" align="justify">
                La información personal de nuestros clientes/usuarios que se recopila mediante los formularios, cupones de
                descuentos y/o documentos análogos alojados en el sitio web de Wong Prime se almacena en nuestros servidores,
                los cuales están alojados en Estados Unidos de América.
              </p>
              <p className="f14" align="justify">
                En ese sentido, con la finalidad de ejecutar las prestaciones que corresponden y que están relacionadas con el
                servicio, y previa declaración ante la Autoridad Nacional de Protección de Datos Personales, Wong Prime
                transfiere a los siguientes Terceros los datos personales cuyo acceso ha sido brindado por usted en condición de
                titular de la Información:
              </p>
              <p className="f14" align="justify">
                <b>Datos recopilados mediante formularios:</b>
              </p>
              <ul className="f14">
                <li>VTEX (Software as a Service) y Amazon - EEUU (Ubicación Física: EEUU. Este - Norte de Virginia us-east-1).</li>
              </ul>
              <p className="f14" align="justify">
                <b>Cupones de descuento:</b>
              </p>
              <ul className="f14">
                <li>
                  IBM EEUU (Ubicación física: WDC01 4030 Lafayette Center Circle, Chantilly, VA 20151 / WDC04 44060 Digital
                  Loudoun Plaza (Bldg K) Ashburn, VA 20147.
                </li>
              </ul>
              <p className="f14" align="justify">
                Es importante resaltar que la única finalidad de dicha transferencia fuera de territorio peruano es el
                almacenamiento, conservación y mantenimiento de los datos personales, y en ningún caso su circulación o uso
                fuera de territorio peruano.
              </p>
              <p className="f14" align="justify">
                Asimismo, en Wong Prime contamos con las medidas de seguridad exigidas por la legislación vigente, a fin de
                resguardar los datos objeto de las transferencias internacionales.
              </p>

              <h3 className="f18">12. CONFIDENCIALIDAD DE LOS DATOS PERSONALES</h3>
              <p className="f14" align="justify">
                Los datos personales facilitados por los clientes/usuarios serán tratados con total confidencialidad. Wong Prime
                se compromete a guardar secreto profesional indefinidamente respecto de los mismos y garantiza el deber de
                guardarlos adoptando todas las medidas de seguridad necesarias.
              </p>

              <h3 className="f18">13. SEGURIDAD DE LOS DATOS PERSONALES</h3>
              <p className="f14" align="justify">
                En cumplimiento de la normativa vigente, en Wong Prime hemos adoptado las medidas técnicas de seguridad
                apropiadas a la categoría de los datos personales necesarias para mantener el nivel de seguridad requerido, con
                el objetivo de evitar la alteración, pérdida o el tratamiento o accesos no autorizados que puedan afectar a la
                integridad, confidencialidad y disponibilidad de la información.
              </p>
              <p className="f14" align="justify">
                En Wong Prime tenemos implementadas todas las medidas de índole legal, técnica y organizativa necesarias para
                garantizar la seguridad de los datos personales y evitar su alteración, pérdida y tratamiento y/o acceso no
                autorizado, teniendo en cuenta el estado de la tecnología, la naturaleza de los datos almacenados y los riesgos
                a que están expuestos, ya sea que provengan de la acción humana, del medio físico o natural, tal y como
                establece la legislación peruana vigente de protección de datos personales.
              </p>
              <p className="f14" align="justify">
                En Wong Prime también tenemos implementadas medidas de seguridad adicionales para reforzar la confidencialidad e
                integridad de la información y continuamente mantenemos la supervisión, control y evaluación de los procesos para
                asegurar la privacidad de los datos personales.
              </p>

              <h3 className="f18">14. MENORES DE EDAD</h3>
              <p className="f14" align="justify">
                En Wong Prime entendemos la importancia de proteger la privacidad de los niños, especialmente en un entorno
                online. Por este motivo, nuestro sitio web no está diseñado ni dirigido a menores de 14 años. Wong Prime no
                llevará a cabo voluntariamente el tratamiento de datos personales relativos a menores de edad. 
                
                <br />
                <br />
                En el supuesto de
                que se tenga conocimiento que los datos personales recogidos corresponden a un menor de edad sin autorización de
                los padres o tutor responsable, se adoptarán las medidas oportunas para eliminar estos datos tan pronto como sea
                posible.
              </p>

              <h3 className="f18">15. SELECCIÓN DE PERSONAL</h3>
              <p className="f14" align="justify">
                Es preciso indicar que los datos personales e información que faciliten los clientes/usuarios en el ícono
                denominado “Trabaja con nosotros” de la Web serán tratados por la empresa Bumeran.com Perú S.A.C., en adelante
                Bumeran, con la que Wong Prime tiene establecido un contrato de servicios para que le facilite la gestión de
                contratación de empleados para cubrir los puestos de trabajo vacantes. La gestión y tratamiento de esta
                información y de los datos personales facilitados se regirán por la Política de Privacidad establecida en esta
                web, cuya dirección electrónica es:{' '}
                <a href="http://cencosud.bumeran.com.pe/login.bum" target="_blank" rel="noopener noreferrer">
                  http://cencosud.bumeran.com.pe/login.bum
                </a>
                .
              </p>
              <p className="f14" align="justify">
                Cabe destacar que los datos de los usuarios recogidos a través de Bumeran se almacenarán en el banco de datos
                denominado “RECLUTAMIENTO DE COLABORADORES” con código de inscripción: RNPDP-PJP N° 1684.
              </p>

              <h3 className="f18">16. EJERCICIO DE DERECHOS ARCO</h3>
              <p className="f14" align="justify">
                Los clientes/usuarios que nos hayan facilitado sus datos personales, pueden dirigirse a Wong Prime, con el fin de
                poder ejercer sus derechos de información, acceso, rectificación, cancelación y oposición en los términos
                recogidos en la legislación peruana vigente.
              </p>
              <p className="f14" align="justify">
                Los clientes/usuarios podrán ejercer sus derechos presentando una solicitud escrita en nuestra oficina principal,
                ubicada en Calle Augusto Angulo Nº 130 Urb. San Antonio Miraflores - Lima, conforme al “Formato Modelo para el
                Ejercicio de Derechos ARCO” en el horario establecido para la atención al público o mediante el envío del formato
                debidamente llenado al correo electrónico:{' '}
                <a href="mailto:atencionsolicitudesarco@cencosud.com.pe">atencionsolicitudesarco@cencosud.com.pe</a>.
              </p>
              <p className="f14" align="justify">
                Para dichos efectos, Wong Prime pone a disposición el “Formato Modelo para el Ejercicio de Derechos ARCO” en el
                siguiente enlace:
              </p>
              <p className="f14" align="center">
                <a
                  className="btn btn-primary"
                  href={`${process.env.PUBLIC_URL || ''}/docs/Solicitud_de_Derechos_ARCO.docx`}
                  download="formato-modelo-derechos-arco.docx"
                >
                  DESCARGAR FORMATO MODELO
                </a>
              </p>
              <p className="f14" align="justify">
                De considerar que no ha sido atendido en el ejercicio de sus derechos, los clientes, prospectos de clientes,
                usuarios, colaboradores y aliados estratégicos, pueden presentar una reclamación ante la Autoridad Nacional de
                Protección de Datos Personales.
              </p>

              <h3 className="f18">17. TIEMPO DE CONSERVACIÓN DE SUS DATOS PERSONALES</h3>
              <p className="f14" align="justify">
                Los datos personales del cliente/usuario serán conservados en los términos establecidos en la LPDP y el RLPDP,
                en el tiempo que sea necesario para cumplir las finalidades identificadas en el punto número 8 de la presente
                Política.
              </p>
              <p className="f14" align="justify">
                Wong Prime, en condición de Titular del banco de datos, se abstendrá de conservar los datos personales del
                Consumidor/titular en los siguientes eventos:
              </p>
              <ul className="f14">
                <li>
                  Cuando tengan conocimiento de su carácter inexacto o incompleto, sin perjuicio de los derechos del
                  cliente/usuario al respecto.
                </li>
                <li>
                  Cuando los datos personales objeto de tratamiento hayan dejado de ser necesarios o pertinentes para el
                  cumplimiento de las finalidades previstas en la presente Política, salvo medie procedimiento de disociación o
                  anonimización.
                </li>
              </ul>
              <p className="f14" align="justify">
                La supresión no procede cuando los datos personales deban ser conservados en virtud de un mandato legal o en
                virtud de razones históricas, estadísticas o científicas de acuerdo con la legislación aplicable o, en su caso,
                en las relaciones contractuales entre el responsable y el titular de los datos personales, que justifiquen el
                tratamiento de los mismos, tal como lo dispone el Reglamento de LPDP.
              </p>

              <h3 className="f18">18. LAS CONSECUENCIAS DE PROPORCIONAR DATOS PERSONALES</h3>
              <p className="f14" align="justify">
                El suministro de los datos personales identificados en la presente Política y la obtención expresa e inequívoca del
                consentimiento contenido en la misma, conducirá al tratamiento de los datos personales suministrados por el
                titular de datos personales, según las finalidades determinadas.
              </p>
              <p className="f14" align="justify">
                Usted en condición de titular de los datos personales puede negarse a proporcionar sus datos personales a Wong
                Prime. Por lo que este último se abstendrá de realizar el tratamiento de sus datos personales, en caso de
                negarse a aceptar la presente Política que contiene el consentimiento para tratamiento de datos personales. En
                este sentido, como consecuencia de dicha acción, usted no podrá acceder al servicio proporcionado por Wong Prime
                toda vez que para el desarrollo del servicio resulta imprescindible contar con los datos personales del titular.
              </p>

              <h3 className="f18">19. VIGENCIA Y MODIFICACIÓN DE LA PRESENTE POLÍTICA DE PRIVACIDAD</h3>
              <p className="f14" align="justify">
                La Política de Privacidad web de Wong Prime ha sido actualizada el mes de abril de 2026.
              </p>
              <p className="f14" align="justify">
                Wong Prime se reserva el derecho a modificar su Política de Privacidad web en el supuesto de que exista un cambio
                en la legislación vigente, doctrinal, jurisprudencial o por criterios propios empresariales. Si se introdujera
                algún cambio en esta Política, el nuevo texto se publicará en este mismo web. Se recomienda a nuestros
                clientes/usuarios que accedan periódicamente a esta Política de privacidad que encontraran en este mismo sitio
                web.
              </p>

              <h3 className="f18">20. OTROS</h3>
              <p className="f14" align="justify">
                Para realizar cualquier tipo de consulta respecto a esta política puede dirigirse a la siguiente dirección de
                correo electrónico:{' '}
                <a href="mailto:servicioalclienteonline@cencosud.com.pe">servicioalclienteonline@cencosud.com.pe</a>.
              </p>
              <p className="f14" align="justify">Fecha de última actualización: 01 de abril de 2026.</p>

              <h3 className="f21">Política de Cookies</h3>
              <h3 className="f18">1. INTRODUCCIÓN</h3>
              <p className="f14" align="justify">
                CENCOSUD RETAIL PERÚ S.A. (en adelante, “Wong Prime”), describe en este documento la “Política de Cookies” que
                regula su sitio web (<a href="https://www.wongprime.pe" target="_blank" rel="noopener noreferrer">https://www.wongprime.pe</a>) con el objetivo de garantizar la privacidad del Usuario del sitio
                web.
              </p>
              <p className="f14" align="justify">
                Estas cookies permiten a Wong Prime facilitar el uso y navegación, garantizar el acceso a determinadas
                funcionalidades y adicionalmente, ayudan a mejorar la calidad del sitio web de acuerdo con los hábitos y estilos
                de navegación del Usuario.
              </p>
              <p className="f14" align="justify">
                Wong Prime utiliza cookies estrictamente necesarias y esenciales para que usted utilice el sitio web y que el
                sitio web funcione correctamente. Asimismo, Wong Prime informa al Usuario que otras cookies sirven para mejorar el
                rendimiento y su experiencia en el sitio web.
              </p>
              <p className="f14" align="justify">
                Wong Prime informa al Usuario que se va a proceder a la recopilación y almacenamiento de los datos personales.
                Dichos datos estarán incorporados en el Banco de Datos denominado CLIENTES inscrito en el Registro Nacional de
                Protección de Datos Personales con el código RNPDP-PJP N° 1680, de titularidad de Wong Prime.
              </p>
              <p className="f14" align="justify">
                Adicionalmente, informamos al Usuario que en nuestro sitio web utilizamos cookies propias como de terceros. De
                acuerdo con ello y la finalidad de ejecutar su funcionalidad, Wong Prime transfiere dentro y fuera de territorio
                peruano los datos personales del Usuario a terceras empresas. La relación de empresas antes mencionadas podrá ser
                consultada a través del siguiente enlace:{' '}
                <a href="https://www.wong.pe/legales/privacidad-datos-proveedores" target="_blank" rel="noopener noreferrer">
                  https://www.wong.pe/legales/privacidad-datos-proveedores
                </a>
                .
              </p>
              <p className="f14" align="justify">
                La recopilación de los datos personales identificados en la presente Política de Cookies y la obtención expresa e
                inequívoca del consentimiento de la misma, conducirá al tratamiento de los datos personales suministrados por el
                Usuario, según las finalidades determinadas. El Usuario puede negarse a proporcionar sus datos personales antes
                señalados; por lo que Wong Prime se abstendrá de realizar el tratamiento de los mismos.
              </p>

              <h3 className="f18">2. ¿QUÉ SON LAS COOKIES?</h3>
              <p className="f14" align="justify">
                Una cookie es un pequeño archivo que se coloca en la computadora, smartphone u otro dispositivo electrónico del
                usuario, y que permite habilitar diversas funcionalidades en los sitios web. Por ejemplo, las cookies permiten
                identificar el dispositivo del usuario, ofrecer acceso seguro a los sitios, e incluso detectar intentos de acceso a
                la cuenta desde dispositivos no reconocidos. Asimismo, las cookies realizan un seguimiento de la sesión del
                usuario, mejoran los tiempos de carga, evitan la repetición de información innecesaria y contribuyen a mostrar
                anuncios que sean relevantes para cada usuario.
              </p>

              <h3 className="f18">3. ¿PARA QUÉ SIRVEN?</h3>
              <p className="f14" align="justify">
                Las cookies se utilizan para mejorar la experiencia de navegación del usuario, ya que constituyen la mejor manera
                de ofrecer contenido personalizado y de interés a través del portal web y la aplicación móvil. Asimismo, permiten
                mostrar publicidad relevante y basada en los intereses del usuario, lo cual genera ingresos que contribuyen a
                mantener la gratuidad de otros servicios ofrecido.
              </p>
              <p className="f14" align="justify">
                Las cookies sirven para reconocer el dispositivo del Usuario cuando vuelven a visitar el sitio web, facilitándole
                su uso recordando sus preferencias y configuración de navegación (por ejemplo: idioma, país, etc.). Asimismo,
                sirven para mejorar los servicios que Wong Prime ofrece y para poder recopilar información estadística que
                permite entender cómo el Usuario utiliza este sitio y permite mejorar su estructura y contenidos.
              </p>
              <p className="f14" align="justify">
                Algunas cookies son estrictamente necesarias para que el sitio web funcione correctamente y otras sirven para
                mejorar el rendimiento y su experiencia como usuario. Las cookies se asocian únicamente a un usuario anónimo y su
                dispositivo de acceso a Internet y no proporcionan referencias que permitan deducir datos personales del
                Usuario. Las cookies no pueden dañar su dispositivo y además son muy útiles, puesto que nos ayudan a identificar y
                resolver errores.
              </p>
              <p className="f14" align="justify">
                Mostramos información sobre nuestra Política de Cookies en la parte superior o inferior cada vez que se accede a
                nuestro sitio web.
              </p>
              <p className="f14" align="justify">Ante esta información, el Usuario puede realizar las siguientes acciones:</p>
              <ul className="f14">
                <li>Aceptar: no se volverá a visualizar este aviso durante la sesión.</li>
                <li>
                  Modificar su configuración: podrá modificar la configuración de su navegación, pero ello no evitará que se
                  muestre el aviso sobre cookies al acceder a nuevas páginas del sitio web.
                </li>
              </ul>
              <p className="f14" align="justify">
                En caso el Usuario decida no elegir entre la aceptación o modificación de la configuración, la información
                indicada se seguirá mostrando durante su navegación a fin de facilitar su acceso y decisión.
              </p>

              <h3 className="f18">4. TIPOS DE COOKIES</h3>
              <p className="f14" align="justify">
                Según cual sea la entidad que gestione el sitio web desde donde se envíen las cookies y traten los datos que se
                obtengan, se pueden distinguir las siguientes:
              </p>
              <ul className="f14">
                <li>
                  Cookies propias: son aquellas que se envían al dispositivo de acceso a Internet del Usuario desde el sitio web
                  gestionada por el propio titular del sitio web y desde el que se presta el servicio solicitado por el Usuario.
                </li>
                <li>
                  Cookies de terceros: son aquellas que se envían al dispositivo de acceso a Internet del Usuario desde el sitio
                  web pero que no es gestionado por el titular del sitio web, sino por otra entidad que trata los datos obtenidos
                  mediante las cookies.
                </li>
              </ul>
              <p className="f14" align="justify">
                Según el plazo de tiempo que permanecen activadas en el dispositivo de acceso a Internet del Usuario, se pueden
                distinguir las siguientes:
              </p>
              <p className="f14" align="justify">
                <b>A.</b> Cookies de sesión: son un tipo de cookies diseñadas para recoger y almacenar datos mientras el Usuario
                accede al sitio web. Se suelen utilizar para almacenar información que sólo interesa conservar para la prestación
                del servicio solicitado por el Usuario en una sola ocasión (la sesión que está utilizando en ese momento).
              </p>
              <p className="f14" align="justify">
                <b>B.</b> Cookies persistentes: son un tipo de cookies en que los datos siguen almacenados en el dispositivo de
                acceso a Internet del Usuario y pueden ser accedidas y tratadas durante un periodo definido por el responsable de
                las cookies, y que puede ir de unos minutos a varios años.
              </p>
              <p className="f14" align="justify">
                Según la finalidad para la que se traten los datos obtenidos mediante las cookies, se pueden distinguir las
                siguientes:
              </p>
              <ul className="f14">
                <li>
                  Cookies Funcionales: Son las que permiten la navegación óptima y el acceso a áreas seguras de la página web, por
                  lo cual la página web no podrá funcionar adecuadamente sin estas cookies. Estas cookies no almacenan ninguna
                  información de identificación personal.
                </li>
                <li>
                  Cookies Analítica y Optimización: Son aquellas que permiten al editor de las mismas, el seguimiento y análisis
                  del comportamiento de los usuarios de los sitios web a los que están vinculados. La información recogida
                  mediante este tipo de cookies se utiliza en la medición de la actividad de los sitios web, aplicación o
                  plataforma y para la elaboración de perfiles de navegación, con el fin de introducir mejoras en función del
                  análisis de los datos de uso que hacen los usuarios del servicio.
                </li>
                <li>
                  Cookies técnicas: las cookies técnicas son aquellas imprescindibles y estrictamente necesarias para el correcto
                  funcionamiento del sitio web y la utilización de las diferentes opciones y servicios que ofrece. Son de este
                  tipo, entre otras, las que sirven para el mantenimiento de la sesión, la gestión del tiempo de respuesta,
                  rendimiento o validación de opciones, utilizar elementos de seguridad o compartir contenido con redes sociales.
                </li>
                <li>
                  Cookies de personalización: son aquellas que permiten al Usuario acceder al servicio con algunas características
                  de carácter general predefinidas en función de una serie de criterios en el dispositivo del Usuario, como por
                  ejemplo serían el idioma, el tipo de navegador que utiliza para acceder al servicio, la configuración regional
                  desde donde accede al servicio, etc.
                </li>
                <li>
                  Cookies de geolocalización: estas cookies son utilizadas para averiguar en qué país se encuentra cuando se
                  solicita un servicio. Estas cookies es totalmente anónima, y sólo se utiliza para ayudar a orientar el contenido
                  a su ubicación.
                </li>
                <li>
                  Cookies de análisis: son aquellas que permiten al responsable de las mismas, el seguimiento y análisis del
                  comportamiento del Usuario en el sitio web. La información recogida mediante este tipo de cookies se utiliza en
                  la medición de la actividad del sitio web y para la elaboración de perfiles de navegación del Usuario con el fin
                  de introducir mejoras en función del análisis de los datos relacionados al uso del servicio.
                </li>
                <li>
                  Cookies publicitarias: son aquellas que permiten la gestión, de la forma más eficaz posible, de los espacios
                  publicitarios que, en su caso, el titular haya incluido en el sitio web desde el que presta el servicio
                  solicitado sobre la base de criterios como el contenido editado o la frecuencia en la que se muestran los
                  anuncios.
                </li>
                <li>
                  Cookies de publicidad comportamental: son aquellas que permiten la gestión, de la forma más eficaz posible de
                  los espacios publicitarios que, en su caso, Wong Prime haya incluido en el sitio web desde el que presta el
                  servicio solicitado. Estas cookies almacenan información del comportamiento del Usuario obtenida por la
                  observación continuada de sus hábitos de navegación, lo que permite desarrollar un perfil específico para mostrar
                  publicidad en función de éste.
                </li>
                <li>
                  Cookies de registro: son aquellas que se generan una vez que el Usuario se ha registrado o posteriormente ha
                  abierto su sesión, y se utilizan para identificarle en los servicios de forma que, si cierra un servicio, el
                  navegador o el ordenador, y en otro momento u otro día vuelve a entrar en dicho servicio, seguirá identificado,
                  facilitando así su navegación sin tener que volver a identificarse. Esta funcionalidad se puede suprimir si el
                  Usuario pulsa la funcionalidad “cerrar sesión”, de forma que estas cookies se eliminan y la próxima vez que
                  entre en el servicio el Usuario tendrá que iniciar sesión para estar identificado.
                </li>
              </ul>

              <h3 className="f18">5. ¿QUÉ TIPO DE COOKIES UTILIZA EL SITIO WEB DE WONG PRIME?</h3>
              <p className="f14" align="justify">
                Las cookies siguientes no identifican personalmente al Usuario, sólo proporcionan información estadística anónima
                sobre la navegación en este sitio web; sin embargo, puede deshabilitarlas directamente configurando su navegador.
              </p>
              <p className="f14" align="justify">A continuación, se listan las cookies que son utilizadas por Wong Prime:</p>
              <ul className="f14">
                <li>
                  Cookies Funcionales: Son las que permiten la navegación óptima y el acceso a áreas seguras de la página web, por
                  lo cual la página web no podrá funcionar adecuadamente sin estas cookies. Estas cookies no almacenan ninguna
                  información de identificación personal.
                </li>
                <li>
                  Cookies Analítica y Optimización: Son aquellas que permiten al editor de las mismas, el seguimiento y análisis
                  del comportamiento de los usuarios de los sitios web a los que están vinculados. La información recogida
                  mediante este tipo de cookies se utiliza en la medición de la actividad de los sitios web, aplicación o
                  plataforma y para la elaboración de perfiles de navegación, con el fin de introducir mejoras en función del
                  análisis de los datos de uso que hacen los usuarios del servicio.
                </li>
              </ul>

              <h3 className="f18">6. GESTIÓN DE LAS COOKIES</h3>
              <p className="f14" align="justify">
                Wong Prime asume un compromiso sobre el uso de cookies, en consecuencia, otorga al Usuario acceso a información
                para que pueda comprender qué tipo de cookies se utiliza en este sitio web y la razón de ello. Con esto, Wong
                Prime pretende proporcionar al Usuario transparencia en cuanto a los datos tratados acerca de la navegación
                realizada desde su equipo en el sitio web.
              </p>
              <p className="f14" align="justify">
                Si el Usuario acepta dichas cookies, permite la mejora del sitio web de Wong Prime para ofrecerle un acceso óptimo
                y darle un servicio más eficaz y personalizado. Además, el Usuario puede configurar su navegador para establecer
                que solo los sitios web de confianza o las páginas por las que está navegando en este momento puedan gestionar
                cookies, lo que le permite seleccionar sus preferencias.
              </p>
              <p className="f14" align="justify">
                En caso de que el Usuario no autorice el uso de cookies, Wong Prime únicamente utilizará aquellas que sean
                técnicas o estrictamente necesarias para garantizar la navegación y el correcto funcionamiento del sitio web. En
                tal situación, no se almacenarán cookies adicionales.
              </p>
              <p className="f14" align="justify">
                Si el Usuario rechaza o elimina las cookies, Wong Prime no podrá recordar sus preferencias. Como consecuencia,
                algunas funciones del sitio podrían no estar disponibles, y se le solicitará nuevamente autorización para el uso
                de cookies cada vez que acceda al sitio web. Esto puede afectar la personalización del servicio y reducir la
                calidad de la experiencia de navegación.
              </p>
              <p className="f14" align="justify">
                Si, aun así, el Usuario decide modificar la configuración de su acceso al sitio web, debe saber que es posible
                eliminar las cookies o impedir que se registre esta información en su equipo en cualquier momento mediante la
                modificación de los parámetros de configuración de su navegador.
              </p>
              <p className="f14" align="justify">
                Para bloquear o deshabilitar las cookies, el Usuario deberá activar la configuración del navegador, de manera que
                se rechace la instalación de todas las cookies o de algunas de ellas. En la práctica la mayoría de los
                navegadores permiten advertir la presencia de cookies o rechazarlas automáticamente. Si son rechazadas se podrá
                seguir usando este sitio web, aunque el uso de algunos de sus servicios podrá ser limitado y por tanto la
                experiencia del Usuario puede ser menos satisfactoria.
              </p>
              <p className="f14" align="justify">Además, existen herramientas externas disponibles para la gestión de cookies:</p>
              <ul className="f14">
                <li>
                  ‘Opt-out’ (desactivación) para cada tipo de cookies: el uso de este sistema puede instalar en tu computadora una
                  cookie “de rechazo” para hacer efectiva la petición de desactivación de cookies solicitada.
                </li>
                <li>Otras herramientas de terceros disponibles online: te permiten detectar todas las cookies de cada web visitada y gestionar su desactivación.</li>
                <li>
                  Sistemas “opt-out” disponibles para Google Analytics:{' '}
                  <a href="https://tools.google.com/dlpage/gaoptout/" target="_blank" rel="noopener noreferrer">
                    https://tools.google.com/dlpage/gaoptout/
                  </a>
                </li>
              </ul>
              <p className="f14" align="justify">
                El Usuario puede elegir qué cookies quiere poner en funcionamiento en este sitio web al modificar la configuración
                del navegador. A modo de ejemplo, facilitamos el acceso a las instrucciones de los navegadores más comunes:
              </p>
              <p className="f14" align="justify">
                <b>(i) Internet Explorer:</b> Herramientas -&gt; Opciones de Internet -&gt; Privacidad -&gt; Configuración. Para más
                información, puede consultar el soporte de Microsoft o la Ayuda del navegador. En cada navegador la operativa
                que ha de seguirse es diferente, pero la función de &quot;Ayuda&quot; de la web de cada navegador le mostrará cómo
                hacerlo, como sucede por ejemplo para Internet Explorer:{' '}
                <a
                  href="https://support.microsoft.com/es-es/windows/eliminar-y-administrar-cookies-168dab11-0753-043d-7c16-ede5947fc64d"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  https://support.microsoft.com/es-es/windows/eliminar-y-administrar-cookies-168dab11-0753-043d-7c16-ede5947fc64d
                </a>
              </p>
              <p className="f14" align="justify">
                <b>(ii) Safari:</b> Preferencias -&gt; Seguridad. Para más información, puede consultar el soporte de Apple o la
                Ayuda del navegador en www.apple.com/es/privacy/use-of-cookies.
              </p>
              <p className="f14" align="justify">
                <b>(iii) Firefox:</b> Herramientas -&gt; Opciones -&gt; Privacidad -&gt; Historial -&gt; Configuración
                Personalizada. Para más información, puede consultar el soporte de Mozilla o la Ayuda del navegador en{' '}
                <a href="https://support.mozilla.org/es/kb/Borrar%20cookies" target="_blank" rel="noopener noreferrer">
                  https://support.mozilla.org/es/kb/Borrar%20cookies
                </a>
                .
              </p>
              <p className="f14" align="justify">
                <b>(iv) Chrome:</b> Configuración -&gt; Mostrar opciones avanzadas -&gt; Privacidad -&gt; Configuración de
                contenido. Para más información, puede consultar el soporte de Google o la Ayuda del navegador en{' '}
                <a href="https://support.google.com/chrome/answer/95647?hl=es" target="_blank" rel="noopener noreferrer">
                  https://support.google.com/chrome/answer/95647?hl=es
                </a>
                .
              </p>
              <p className="f14" align="justify">
                Wong Prime no es responsable del contenido y veracidad de las políticas de privacidad de los terceros
                referenciadas en esta política de cookies.
              </p>

              <h3 className="f18">7. ¿CUÁNDO SE ACTUALIZA ESTA POLÍTICA DE COOKIES?</h3>
              <p className="f14" align="justify">
                Wong Prime puede modificar esta Política de Cookies para cumplir con las obligaciones legales, reglamentarias y/o
                administrativas que nos apliquen o cuando consideremos que ha habido un cambio oportuno. Wong Prime publicará la
                nueva política de cookies en este sitio web, por lo que te pedimos que revises esta política de manera periódica.
              </p>

              <h3 className="f18">8. CONSULTAS</h3>
              <p className="f14" align="justify">
                Para realizar cualquier tipo de consulta respecto a esta política puede dirigirse a la siguiente dirección de
                correo electrónico:{' '}
                <a href="mailto:servicioalclienteonline@cencosud.com.pe">servicioalclienteonline@cencosud.com.pe</a>.
              </p>

              <h3 className="f18">9. VIGENCIA Y MODIFICACIÓN DE LA PRESENTE POLÍTICA DE COOKIES</h3>
              <p className="f14" align="justify">
                Wong Prime puede modificar esta Política de Cookies en función de exigencias legislativas, reglamentarias,
                jurisprudenciales o con la finalidad de adaptar dicha política a las instrucciones dictadas por la Autoridad
                Nacional de Protección de Datos Personales, así como por criterios propios institucionales.
              </p>
              <p className="f14" align="justify">Fecha de última actualización: 01 de abril de 2026.</p>

              <h3 className="f21">Protección de Datos Personales</h3>
              <h4 className="f18">1. INFORMACIÓN PARA NUESTROS CLIENTES</h4>
              <p className="f14" align="justify">
                Los datos personales que el Cliente ha facilitado para la compra de los productos en nuestra tienda virtual o el
                tratamiento consentido para finalidades adicionales son utilizados con la finalidad de ejecutar la relación
                contractual que lo vincula con nosotros, así como los tratamientos adicionales informados en nuestra Política de
                Privacidad y forman parte del banco de datos denominado “Clientes” de titularidad de Cencosud Retail Perú S.A. (en
                adelante Wong Prime).
              </p>
              <p className="f14" align="justify">
                El Cliente puede ejercer sus derechos de información, acceso, rectificación, cancelación y oposición, respecto de
                sus datos personales en los términos previstos en la Ley N° 29733 – Ley de Protección de Datos Personales, y su
                Reglamento aprobado por el Decreto Supremo N° 016-2024-JUS, conforme a lo indicado en el acápite siguiente
                “Información para el Ejercicio de Derechos ARCO”.
              </p>
              <h4 className="f18">2. INFORMACIÓN PARA EL EJERCICIO DE DERECHOS ARCO</h4>
              <p className="f14" align="justify">
                El titular de los datos personales, para ejercer sus derechos de información, acceso, rectificación,
                cancelación y oposición, o cualquier otro que la ley establezca, deberá presentar una solicitud escrita en nuestra
                oficina principal ubicada en Calle Augusto Angulo Nº 130 Urb. San Antonio Miraflores – Lima, conforme al “Formato
                Modelo para el Ejercicio de Derechos ARCO” en el horario establecido para la atención al público o mediante el
                envío del formato debidamente llenado al correo electrónico:{' '}
                <a href="mailto:atencionsolicitudesarco@cencosud.com.pe">atencionsolicitudesarco@cencosud.com.pe</a>.
              </p>
              <h4 className="f18">3. FORMATOS MODELO PARA EL EJERCICIO DE DERECHOS ARCO</h4>
              <p className="f14">En el siguiente enlace puede descargar el Formato Modelo para el Ejercicio de Derechos ARCO.</p>
              <p className="f14" align="center">
                <a
                  className="btn btn-primary"
                  href={`${process.env.PUBLIC_URL || ''}/docs/Solicitud_de_Derechos_ARCO.docx`}
                  download="formato-modelo-derechos-arco.docx"
                >
                  DESCARGAR FORMATO MODELO
                </a>
              </p>
              <h3 className="f21">Hoja Informativa sobre Tratamiento de Datos Personales</h3>
              <p className="f14" align="justify">
                CENCOSUD RETAIL PERU S.A (en adelante, “Wong Prime”), con RUC N° 20109072177, con domicilio en Calle Augusto
                Angulo Nº 130, Urb. San Antonio, distrito de Miraflores, provincia y departamento de Lima; en el marco de la Ley
                N° 29733, Ley de Protección de Datos Personales (en adelante, la LPDP), su reglamento, modificatorias y normas
                complementarias vigentes, recopilará sus datos personales -imagen- para brindar seguridad y controlar las
                operaciones y actividades de la empresa, así como para realizar el control laboral de sus trabajadores, los
                cuales serán incorporadas en nuestro banco de datos personales denominado “VIDEOVIGILANCIA” con Código de Registro
                N° 1686.
              </p>
              <h4 className="f18">I. LA FINALIDAD DEL TRATAMIENTO DE DATOS PERSONALES</h4>
              <p className="f14" align="justify">
                Wong Prime tratará las imágenes y/o filmaciones adquiridas con las cámaras de videovigilancia con fines de
                seguridad y controlar las operaciones y actividades de seguridad propias de la empresa. Asimismo, las imágenes y/o
                filmaciones de los colaboradores de Wong Prime, obtenidas mediante las cámaras de videovigilancia, serán objeto de
                tratamiento con la finalidad de controlar y supervisar el cumplimiento de sus obligaciones y deberes laborales.
              </p>
              <p className="f14" align="justify">
                El tratamiento de los datos personales realizado por Wong Prime no se extenderá a otra finalidad que no haya sido
                la establecida de manera inequívoca como tal en el presente documento, excluyendo los casos de actividades de valor
                histórico, estadístico o científico cuando se utilice un procedimiento de disociación o anonimización.
              </p>
              <h4 className="f18">II. COMUNICACIÓN DE DATOS PERSONALES</h4>
              <p className="f14" align="justify">
                Wong Prime respeta la privacidad de sus clientes, prospectos de clientes, usuarios, proveedores, visitantes y
                colaboradores; por lo que no se compartirá su información con terceros si el titular de los datos personales no
                desea expresamente que estos sean compartidos.
              </p>
              <p className="f14" align="justify">
                Wong Prime, como titular del banco de datos personales, podrá comunicar los datos personales a las entidades
                administrativas, autoridades judiciales y/o policiales, siempre y cuando esté establecido por Ley.
              </p>
              <h4 className="f18">III. EL EJERCICIO DE LOS DERECHOS ARCO</h4>
              <p className="f14" align="justify">
                El titular de los datos personales puede ejercer sus derechos de acceso, rectificación, cancelación y oposición,
                en los términos dispuestos en la Ley N° 29733 y su Reglamento, aprobado por Decreto Supremo N° 016-2024-JUS,
                enviando un correo electrónico dirigido a{' '}
                <a href="mailto:atencionsolicitudesarco@cencosud.com.pe">atencionsolicitudesarco@cencosud.com.pe</a>, con la
                referencia “Protección de Datos Personales”, especificando sus datos, acreditando su identidad y los motivos de su
                solicitud, de ser necesario.
              </p>
              <p className="f14" align="justify">
                De considerar que no ha sido atendido en el ejercicio de sus derechos puede presentar una reclamación ante la
                Autoridad Nacional de Protección de Datos Personales, dirigiéndose a la Mesa de Partes del Ministerio de Justicia
                y Derechos Humanos: Calle Scipión Llona 350, distrito de Miraflores, provincia y departamento de Lima.
              </p>
              <h4 className="f18">IV. PLAZO DE CONSERVACIÓN DE LOS DATOS PERSONALES</h4>
              <p className="f14" align="justify">
                Las imágenes y/o filmaciones adquiridas mediante las cámaras de videovigilancia, se conservarán por un periodo de
                treinta (30) días, el cual podrá ser ampliado por un periodo máximo de sesenta (60) días, salvo disposición
                distinta en normas sectoriales.
              </p>
              <p className="f14" align="justify">
                En relación con las imágenes y/o filmaciones adquiridas de los colaboradores de Wong Prime que den cuenta de la
                comisión de presuntas infracciones laborales y/o accidentes de trabajo serán conservadas por el plazo de ciento
                veinte (120) días, contados a partir de su conocimiento.
              </p>
              <p className="f14" align="justify">
                Transcurridos los plazos de conservación mencionados, y no habiendo requerimiento de alguna autoridad competente
                para entregar o visualizar el contenido de las grabaciones, se deben eliminar los archivos en el plazo máximo de
                dos (02) días hábiles, salvo disposición distinta en norma sectorial.
              </p>
              <p className="f14" align="justify">
                El plazo máximo previsto para la eliminación de información no será aplicable cuando exista alguna finalidad que
                justifique su conservación o interés legítimo que justifique su conservación, así como la concurrencia de alguna
                contingencia de orden técnico que justifique razonablemente el aplazamiento de la eliminación de la misma por un
                periodo determinado o determinable.
              </p>
              <p className="f14" align="justify">
                La supresión no procede cuando los datos personales deban ser conservados en virtud de un mandato legal o en
                virtud de razones históricas, estadísticas o científicas de acuerdo con la legislación aplicable o, en su caso, en
                las relaciones contractuales entre el responsable y el titular de los datos personales, que justifiquen el
                tratamiento de los mismos, tal como lo dispone el artículo 69 del Reglamento de LPDP.
              </p>
              <h4 className="f18">V. CONFIDENCIALIDAD Y MEDIDAS DE SEGURIDAD</h4>
              <p className="f14" align="justify">
                Con el objeto de evitar la pérdida, mal uso, alteración, acceso no autorizado y robo de los datos personales o
                información confidencial facilitados por titulares de datos personales, Wong Prime ha adoptado los niveles de
                seguridad y de protección de datos personales legalmente requeridos, y ha instalado todos los medios y medidas
                técnicas a su alcance.
              </p>
              <p className="f14" align="justify">
                Para mayor información sobre nuestra Política de Privacidad sírvase consultar al siguiente enlace{' '}
                <a href="https://www.wongprime.pe/institucional/politicas-privacidad-seguridad" target="_blank" rel="noopener noreferrer">
                  https://www.wongprime.pe/institucional/politicas-privacidad-seguridad
                </a>
                .
              </p>
              <h4 className="f18">VI. OFICIAL DE DATOS PERSONALES</h4>
              <ul className="f14">
                <li>Nombre completo: Ernesto Ladrón de Guevara Horna</li>
                <li>
                  Correo electrónico:{' '}
                  <a href="mailto:atencionsolicitudesarco@cencosud.com.pe">atencionsolicitudesarco@cencosud.com.pe</a>
                </li>
                <li>
                  Dirección institucional: Calle Augusto Angulo N° 130, Urb. San Antonio, distrito de Miraflores, provincia y
                  departamento de Lima.
                </li>
              </ul>
              <p className="f14" align="justify">
                Para consultas, solicitudes o ejercicios de derechos ARCO, contáctenos al correo indicado.
              </p>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Policies;
